module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/alcon-8099b3fe3e31d2f0259dcd8714df0599.png";